import React, { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useGetJobsFacetsQuery } from '@core/react/jobs-filter/redux/fetchApiSlice';
import GroupedFormView from './View';
import OnFormSubmitted from './Service';

function GroupedForm() {
	const dispatch = useDispatch();
	const { keyword, city, radius, isResetClicked } = useSelector(
		(state) => state.jobsFormInput,
	);

	const { data } = useGetJobsFacetsQuery();

	// const { locationRadius } = data;

	const textSearchRef = useRef();
	const locationRef = useRef();
	const radiusRef = useRef();

	if (isResetClicked) {
		textSearchRef.current.value = '';
		locationRef.current.value = '';
		radiusRef.current.value = '';
	}

	// combined all refs into one object
	const mergedRefs = {
		textSearchRef,
		locationRef,
		radiusRef,
	};

	// set default values
	const mergedDefaultValues = {
		defaultKeyword: keyword,
		defaultCity: city,
		defaultRadius: radius,
	};

	const HandleFormSubmit = () =>
		OnFormSubmitted(dispatch, textSearchRef, locationRef, radiusRef);

	if (!data) return null;

	const { locationRadius } = data;

	// const locationRadiusArray = Object.keys(locationRadius);
	const locationRadiusArray = Object.entries(locationRadius).map(
		([key, value]) => ({
			value: key,
			label: value,
		}),
	);

	return (
		<GroupedFormView
			ref={mergedRefs}
			onClick={HandleFormSubmit}
			locationRadius={locationRadiusArray}
			mergedDefaultValues={mergedDefaultValues}
		/>
	);
}

export default GroupedForm;
